import { render, staticRenderFns } from "./step8.vue?vue&type=template&id=0dfcdca8&scoped=true&"
import script from "./step8.vue?vue&type=script&lang=js&"
export * from "./step8.vue?vue&type=script&lang=js&"
import style0 from "./step8.vue?vue&type=style&index=0&id=0dfcdca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfcdca8",
  null
  
)

export default component.exports